import { QuoteCurrencyListExceptUsdt, UsdtCurrency } from '@flipster/utils/constants/currency';

/** quoteCurrency 만 필요하므로 인스트루먼트 전체 타입에 의존하지 않는다. */
interface QuoteCurrencyBearing {
  quoteCurrency: string;
}

/**
 * 마켓이 사용자에게 노출할 quote currency 목록.
 *
 * USDT 외 통화는 **큐레이션 목록에 있고(AND) 실제로 상장돼 있어야** 노출된다.
 * 마켓 탭·캐러셀 카드·어트리뷰션 코드가 이미 `QuoteCurrencyListExceptUsdt` + 서버 layout 의
 * AND 조건인데 문구만 상장 데이터만 봤다면, 같은 통화가 문구에는 나오고 탭에는 없는 상태가 된다.
 * 노출 경로 전체를 같은 게이트로 맞춘다.
 *
 * 이 방식은 QA 도 결정적으로 만든다 — 큐레이션 목록이 비어 있으면 ns 에 어떤 심볼이 상장돼
 * 있든 문구는 USDT 만 표시한다.
 *
 * USDT 는 상장 여부를 따지지 않고 항상 포함한다. 스냅샷 로딩 구간에 빈 목록을 렌더하면
 * 빈 괄호 같은 깨진 문구가 나오고, USDT 는 항상 quote currency 이므로 틀린 정보가 되지 않는다.
 *
 * 순서는 큐레이션 목록 순서를 따르며, 구분자는 호출부가 정한다
 * (마켓 캐러셀은 ' / ', VIP 테이블은 ' & ').
 */
export const resolveDisplayQuoteCurrencies = (instruments: readonly QuoteCurrencyBearing[]): string[] => {
  const listed = new Set(instruments.map((instrument) => instrument.quoteCurrency));
  return [UsdtCurrency, ...QuoteCurrencyListExceptUsdt.filter((currency) => listed.has(currency))];
};
